import React, { useEffect, useState } from "react";
import AdminAppBar from "../components/adminComponents/AdminAppBar";
import { GoPerson } from "react-icons/go";
import { MdKeyboardArrowRight } from "react-icons/md";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { IoSettingsOutline } from "react-icons/io5";
import Images from "../PropertyProcurementComponents/Constants/Images";
import { IoSunnySharp } from "react-icons/io5";
import { FaCloudSun } from "react-icons/fa6";
import { IoPartlySunnySharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { getBasePathByUserRole } from "../utils/roleRoutes";
import { MdUpgrade } from "react-icons/md";
import { IoLockClosed } from "react-icons/io5";
import GreetingBanner from "./GreetingBanner";
import { accessModule, userName, userRole } from "../utils/storage";
import { getIcons, getLogos } from "../components/Constant/Constant";

const GLNavigationSystem = () => {
  const [greeting, setGreeting] = useState({});
  const [hoveredApp, setHoveredApp] = useState(null);
  const navigate = useNavigate();
const logo = getLogos();
  const path = getBasePathByUserRole();

  // Updated systemnavigation with accessStatus and fixed typo in Accounts Pro
  const systemnavigation = [
    {
      image: Images.PropertyProcurementImage,
      label: "Property Procurement",
      navigate: "/propertyprocurement-list",
      accessStatus: false,
      isPlan: true,
      planType: "Premium",
      description: "Manage your property procurement process efficiently",
      upgradeMessage: "Upgrade to Premium to access Property Procurement",
    },
    {
      image: Images.GLImage,
      label: "GL Funnel CRM",
      navigate: `${path}/dashboard`,
      accessStatus: accessModule.glFunnelModule || false,
      isPlan: true,
      planType: "Standard",
      description: "Complete CRM solution for lead management",
    },
    {
      image: Images.TaskImage,
      label: "Task Manager",
      navigate: null,
      accessStatus: false,
      isPlan: false,
      planType: "Premium",
      description: "Organize and track your team's tasks",
      upgradeMessage: "Upgrade to Premium to access Task Manager",
    },
    {
      image: Images.AccountImage,
      label: "Accounts Pro",
      navigate: null,
      accessStatus:  false,
      isPlan: false,
      planType: "Enterprise",
      description: "Advanced accounting and financial management",
      upgradeMessage: "Upgrade to Enterprise plan for Accounts Pro",
    },
    {
      image: Images.HRImage,
      label: "HR Management",
      navigate: "/hr-employee-analytics",
      accessStatus: false,
      isPlan: true,
      planType: "Standard",
      description: "Human resource management system",
    },
    {
      image: Images.GEOImage,
      label: "GEO Tracking",
      navigate: "/geo-location-dashboard",
      accessStatus:  false,
      isPlan: true,
      planType: "Premium",
      description: "Advanced location tracking and analytics",
    },
    {
      image: Images.HRImage,
      label: "Global Setup",
      navigate: "/global-setup",
      accessStatus: true,
      isPlan: true,
      planType: "Standard",
      description: "Global configurations and settings",
    },
  ];

  const handleAppClick = (app) => {
    if (app.accessStatus && app.isPlan && app.navigate) {
      navigate(app.navigate);
    } else if (!app.accessStatus || !app.isPlan) {
      console.log(`Please upgrade to ${app.planType} plan to access ${app.label}`);
    }
  };

  useEffect(() => {
    const hour = new Date().getHours();
    if (hour < 12) {
      setGreeting({
        label: "Good Morning",
        icon: <IoSunnySharp className="text-yellow-400 text-2xl" />,
        bgImage: Images.MorningImage,
      });
    } else if (hour < 18) {
      setGreeting({
        label: "Good Afternoon",
        icon: <FaCloudSun className="text-orange-400 text-2xl" />,
        bgImage: Images.AfternoonImage,
      });
    } else {
      setGreeting({
        label: "Good Evening",
        icon: <IoPartlySunnySharp className="text-blue-400 text-2xl" />,
        bgImage: Images.EveningImage,
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      <AdminAppBar isMenu={false} />
      <div className="px-6 pt-28 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-3">
            <div className="bg-white rounded-3xl shadow-xl p-8 flex flex-col justify-between h-full min-h-[650px] border border-gray-100">
              <div className="flex flex-col items-center gap-8">
                <div className="relative">
                  <img
                    src={logo.clientLogo}
                    className="rounded-full w-32 h-32 object-cover border-4 border-green-100 shadow-lg"
                    alt="Profile"
                  />
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-800 mb-1">
                   {userName}
                  </h3>
                  <p className="text-gray-500 bg-gray-100 px-4 py-1 rounded-full text-sm">
                    {userRole}
                  </p>
                </div>
                <div className="w-full space-y-4">
                  <div className="flex items-center justify-between p-2 rounded-xl bg-gradient-to-r from-blue-50 to-indigo-50 hover:from-blue-100 hover:to-indigo-100 cursor-pointer transition-all duration-300 border border-blue-100 hover:border-blue-200">
                    <div className="flex items-center gap-4">
                      <div className="p-2 bg-blue-500 rounded-lg">
                        <IoSettingsOutline className="text-white text-lg" />
                      </div>
                      <span className="font-semibold text-gray-700">
                        Support Center
                      </span>
                    </div>
                    <MdKeyboardArrowRight className="text-blue-500 text-xl" />
                  </div>
                  <div onClick={
                    (e) => {
                      navigate(`${path}/my-profile` , {
                        state: { isMenu: false }
                      });
                    }
                  } className="flex items-center justify-between p-2 rounded-xl bg-gradient-to-r from-green-50 to-emerald-50 hover:from-green-100 hover:to-emerald-100 cursor-pointer transition-all duration-300 border border-green-100 hover:border-green-200">
                    <div className="flex items-center gap-4">
                      <div className="p-2 bg-green-500 rounded-lg">
                        <GoPerson className="text-white text-lg" />
                      </div>
                      <span className="font-semibold text-gray-700">
                        My Profile
                      </span>
                    </div>
                    <MdKeyboardArrowRight className="text-green-500 text-xl" />
                  </div>
                </div>
              </div>
              <div className="mt-8">
                <div onClick={()=>{
                  localStorage.clear();
                  navigate("/");
                  window.location.reload();
                }}  className="flex items-center justify-center gap-4 p-2 rounded-xl bg-gradient-to-r from-red-50 to-pink-50 hover:from-red-100 hover:to-pink-100 cursor-pointer transition-all duration-300 border border-red-100 hover:border-red-200">
                  <span className="font-semibold text-red-600">Sign Out</span>
                  <RiLogoutCircleRLine className="text-red-600 text-xl" />
                </div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-9 space-y-6">
            <div className="flex flex-col sm:flex-row items-center gap-6">
              <GreetingBanner />
              <div className="flex-1 bg-white rounded-2xl shadow p-6 border border-gray-100">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      Welcome To Eco System
                    </h3>
                    <p className="text-gray-500 text-sm">
                      Manage your business operations efficiently
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                Your Apps
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-4 gap-6">
                {systemnavigation.map((app, index) => {
                  // Determine card state
                  const isAccessible = app.accessStatus && app.isPlan;
                  const needsUpgrade = app.isPlan ? app.accessStatus : !app.accessStatus;
                  const isLocked = !app.accessStatus;

                  return (
                    <div
                      key={index}
                      onClick={() => handleAppClick(app)}
                      onMouseEnter={() => setHoveredApp(index)}
                      onMouseLeave={() => setHoveredApp(null)}
                      className={`relative group p-5 rounded-2xl transition-all duration-300 border-2 ${
                        isAccessible
                          ? "bg-white hover:bg-gradient-to-br hover:from-green-50 hover:to-emerald-50 border-gray-200 hover:border-green-300 hover:shadow-xl transform hover:-translate-y-2 cursor-pointer"
                          : needsUpgrade
                          ? "bg-gradient-to-br from-orange-50 to-yellow-50 border-orange-200 hover:border-orange-300 hover:shadow-lg cursor-pointer"
                          : "bg-gradient-to-br from-gray-50 to-gray-100 border-gray-300 opacity-60 cursor-not-allowed"
                      }`}
                    >
                      {/* Status Badge */}
                      <div className="absolute top-3 right-3">
                        {isAccessible ? (
                          <></>
                        ) : needsUpgrade ? (
                          <div className="p-2 bg-orange-100 rounded-full">
                            <MdUpgrade className="text-orange-500 text-xl" />
                          </div>
                        ) : (
                          <div className="p-2 bg-red-100 rounded-full">
                            <IoLockClosed className="text-red-500 text-sm" />
                          </div>
                        )}
                      </div>

                     
                      <div className="flex flex-col items-center text-center space-y-4 mt-6">
                        <div
                          className={`w-16 h-16 flex items-center justify-center rounded-2xl p-4 transition-all duration-300 ${
                            isAccessible
                              ? "bg-green-50 group-hover:bg-green-100 group-hover:scale-110"
                              : needsUpgrade
                              ? "bg-orange-50 group-hover:bg-orange-100"
                              : "bg-gray-200"
                          }`}
                        >
                          <img
                            src={app.image}
                            alt={app.label}
                            className={`w-full h-full object-contain transition-all duration-300 ${
                              isLocked
                                ? "grayscale opacity-40"
                                : needsUpgrade
                                ? "opacity-80"
                                : "group-hover:scale-110"
                            }`}
                          />
                        </div>
                        
                        <div>
                          <h3 className={`font-semibold text-base mb-1 ${
                            isAccessible
                              ? "text-gray-800"
                              : needsUpgrade
                              ? "text-orange-700"
                              : "text-gray-500"
                          }`}>
                            {app.label}
                          </h3>
                          <p className={`text-[11px] ${
                            isAccessible
                              ? "text-gray-600"
                              : needsUpgrade
                              ? "text-orange-600"
                              : "text-gray-400"
                          }`}>
                            {app.description}
                          </p>
                        </div>

                        {/* Action Button */}
                        <div className="w-full mt-4">
                          {isAccessible ? (
                            <div className="px-4 py-2 bg-customGreen text-white rounded-lg text-sm font-semibold opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                              Open Application
                            </div>
                          ) : needsUpgrade ? (
                            <div className="px-4 py-2 text-nowrap bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg text-sm font-semibold opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0 flex items-center justify-center gap-2">
                        
                              Upgrade to {app.planType}
                            </div>
                          ) : (
                            <div className="px-4 py-2 bg-gray-400 text-white rounded-lg text-sm font-semibold opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                              Access Denied
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Tooltip */}
                      {(!isAccessible) && hoveredApp === index && (
                        <div className="absolute -top-16 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap z-50 shadow-xl">
                          <div className="text-center">
                            <div className="font-semibold">
                              {needsUpgrade 
                                ? `Upgrade to ${app.planType} plan for ${app.label}`
                                : app.upgradeMessage || `Access to ${app.label} is restricted`
                              }
                            </div>
                          </div>
                          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GLNavigationSystem;